<template>
  <b-container class="variableDiv" fluid>

    <template v-if="isSimple">
      <b-row>
        <b-col cols="2"><div class="text-left varLabel">{{variableData.title}}:</div></b-col>
        <b-col class="text-left">{{getValue}}</b-col>
      </b-row>
    </template>

    <template v-else-if="isText">
      <b-row>
        <b-col><div class="text-left varLabel">{{variableData.title}}</div></b-col>
      </b-row>

      <b-row>
        <b-col><BTextarea :value="getValue" readonly ></BTextarea></b-col>
      </b-row>
    </template>

    <template v-else-if="isList">
      <b-row>
        <b-col><div class="text-left varLabel">{{variableData.title}}</div></b-col>
      </b-row>

      <b-row>
        <ul>
          <li v-for="(choice,idx) in variableData.values" :key="idx">
            {{choice}}

          </li>
        </ul>

      </b-row>

    </template>



  </b-container>
</template>

<script>
// import {mapGetters, mapState} from "vuex";

export default {
  name: 'VariableComponent',

  props: {
    variableData: Object
  },

  components: {
    // Widget, ViewPathWidget
  },

  computed: {
    isSimple() {
      return this.variableData.type==='simple'
    },

    isText() {
      return this.variableData.type==='text'
    },

    isList() {
      return this.variableData.type==='list'
    },

    getValue() {
      return this.variableData.values.length>0 ? this.variableData.values[0] : "";
    }

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.varLabel {
  font-weight: bold;
}

.variableDiv {
  background-color: #e7e6e6;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 1em;
}

</style>
